export default __webpack_public_path__ + "static/media/14.d21db33f.png";